// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".azure-queue-custom-divider{\n  margin:8px 0;\n}\n.azure-queue-container p{\n  margin-bottom:1px;\n}", "",{"version":3,"sources":["webpack://./src/pages/Diagnostics/Queue/AzureQueue/AzureQueue.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".azure-queue-custom-divider{\n  margin:8px 0;\n}\n.azure-queue-container p{\n  margin-bottom:1px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
